import { defineComponent as _defineComponent } from 'vue'
import HelpBox from "@/components/icons/help/IconHelpBox.vue";
import HelpBriefcase from "@/components/icons/help/IconHelpBriefcase.vue";
import HelpFirstline from "@/components/icons/help/IconHelpFirstline.vue";
import HelpFolderOpen from "@/components/icons/help/IconHelpFolderOpen.vue";
import HelpLayer from "@/components/icons/help/IconHelpLayer.vue";
import HelpPause from "@/components/icons/help/IconHelpPause.vue";
import HelpQuoteUp from "@/components/icons/help/IconHelpQuoteUp.vue";
import HelpScreenmirroring from "@/components/icons/help/IconHelpScreenmirroring.vue";
import HelpTextalignLeft from "@/components/icons/help/IconHelpTextalignLeft.vue";
import { Link } from "@inertiajs/vue2";


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpResult',
  setup(__props) {

const slugIcons = {
  slug0: HelpFirstline,
  slug1: HelpFolderOpen,
  slug2: HelpLayer,
  slug3: HelpPause,
  slug4: HelpQuoteUp,
  slug5: HelpScreenmirroring,
  slug6: HelpBox,
  slug7: HelpBriefcase,
  slug8: HelpTextalignLeft,
};

const searchResult = [
  {
    slug: "slug0",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug1",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug2",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug3",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug4",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug5",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug6",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug7",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug8",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
];

return { __sfc: true,slugIcons, searchResult, Link }
}

})